import { render, staticRenderFns } from "./About_EASI.vue?vue&type=template&id=4e82c464&scoped=true&"
import script from "./About_EASI.vue?vue&type=script&lang=js&"
export * from "./About_EASI.vue?vue&type=script&lang=js&"
import style0 from "./About_EASI.vue?vue&type=style&index=0&id=4e82c464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82c464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
